import createReducer from '@/lib/redux_updeep';

const initialState = {};

export default createReducer('CUSTOMER', initialState, {});
